/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getAuthorizedClients = /* GraphQL */ `
  query GetAuthorizedClients($token: String) {
    getAuthorizedClients(token: $token) {
      Clients {
        AssignedRole
        AssignedRoleExpiration
        ClientAccountAlias
        ClientAccountId
        Description
        EffectiveRole
      }
      DataLakeRole
    }
  }
`;
export const getDatasetTables = /* GraphQL */ `
  query GetDatasetTables($limit: Int, $nextToken: String, $resourceId: ID!) {
    getDatasetTables(
      limit: $limit
      nextToken: $nextToken
      resourceId: $resourceId
    )
  }
`;
export const getExecution = /* GraphQL */ `
  query GetExecution($executionId: ID!) {
    getExecution(executionId: $executionId) {
      ClientAccountId
      Configuration
      Description
      EndTime
      ExecutionId
      Feed
      Inputs
      Message
      Metrics
      Outputs
      Overrides
      Result
      SourceDatasetIds
      StartTime
      Status
      TargetDatasetId
      Tasks
      WorkloadId
      WorkloadType
    }
  }
`;
export const getExecutionInput = /* GraphQL */ `
  query GetExecutionInput($executionId: ID!, $inputUri: ID!) {
    getExecutionInput(executionId: $executionId, inputUri: $inputUri) {
      Attempts
      ClientAccountId
      EndTime
      ExecutionId
      InputSha256
      InputSizeInBytes
      InputUri
      LogStream
      Metrics
      Outputs
      Result
      ResultSummary
      SourceDatasetId
      Status
      SubmitTime
      UpdateTime
      WorkloadId
    }
  }
`;
export const getExecutionInputLog = /* GraphQL */ `
  query GetExecutionInputLog(
    $executionId: ID!
    $inputUri: ID!
    $limit: Int
    $nextToken: String
    $retrievalMode: LogRetrievalMode
  ) {
    getExecutionInputLog(
      executionId: $executionId
      inputUri: $inputUri
      limit: $limit
      nextToken: $nextToken
      retrievalMode: $retrievalMode
    ) {
      events {
        ingestionTime
        message
        timestamp
      }
      nextBackwardToken
      nextForwardToken
    }
  }
`;
export const getResource = /* GraphQL */ `
  query GetResource($resourceId: ID) {
    getResource(resourceId: $resourceId) {
      ClientAccountId
      Description
      Metrics
      Region
      ResourceId
      ResourceMigration
      ResourceSubtype
      ResourceType
      ResourceVersion
      StackCreated
      StackName
      StackUpdated
      ... on Client {
        ClientAccountAlias
        ClientConfiguration
      }
      ... on Credential {
        CredentialArn
        SecurityConfiguration
        TargetResource
        TargetResourceSpec
        UserArn
      }
      ... on Dataset {
        CatalogConfiguration
        CompactionConfiguration
        Location
        Migration
        Schema
        SecurityConfiguration
      }
      ... on Datastore {
        AuthorizedReadOnlyAccountIds
        AuthorizedReadWriteAccountIds
        Bucket
        BucketConfiguration
        SecurityConfiguration
      }
      ... on LandingZone {
        AuthorizedReadOnlyAccountIds
        AuthorizedReadWriteAccountIds
        Bucket
        BucketConfiguration
        SecurityConfiguration
      }
      ... on Stream {
        StorageConfiguration
        StreamConfiguration
      }
      ... on Subscription {
        DeliveryConfiguration
        SubscribedResource
      }
      ... on Workload {
        ArrivalFeedConfiguration
        ClusterConfiguration
        CompactionConfiguration
        ContainerType
        ControllerConfiguration
        DataConfiguration {
          SourceDatasetIds
          TargetDatasetId
        }
        ExecutionType
        WorkloadConfiguration
        WorkloadInputs
      }
    }
  }
`;
export const getResourceDependencies = /* GraphQL */ `
  query GetResourceDependencies($resourceId: ID!) {
    getResourceDependencies(resourceId: $resourceId) {
      DependsOnResourceId
      DependsOnResourceType
      ReferencingElements
      ResourceId
      ResourceType
      Updated
    }
  }
`;
export const getResourceLog = /* GraphQL */ `
  query GetResourceLog(
    $endTime: Int
    $limit: Int
    $resourceId: ID!
    $startTime: Int
  ) {
    getResourceLog(
      endTime: $endTime
      limit: $limit
      resourceId: $resourceId
      startTime: $startTime
    )
  }
`;
export const getUserData = /* GraphQL */ `
  query GetUserData($type: String) {
    getUserData(type: $type) {
      Data
      Id
      LastUpdate
      Type
    }
  }
`;
export const listExecutionInputs = /* GraphQL */ `
  query ListExecutionInputs(
    $filter: _ExecutionInputFilter
    $limit: Int
    $nextToken: String
    $order: SortDirection
    $orderBy: ExecutionInputOrderBy
  ) {
    listExecutionInputs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      order: $order
      orderBy: $orderBy
    ) {
      items {
        Attempts
        ClientAccountId
        EndTime
        ExecutionId
        InputSha256
        InputSizeInBytes
        InputUri
        LogStream
        Metrics
        Outputs
        Result
        ResultSummary
        SourceDatasetId
        Status
        SubmitTime
        UpdateTime
        WorkloadId
      }
      nextToken
    }
  }
`;
export const listExecutions = /* GraphQL */ `
  query ListExecutions(
    $filter: _ExecutionFilter
    $limit: Int
    $nextToken: String
  ) {
    listExecutions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        ClientAccountId
        Configuration
        Description
        EndTime
        ExecutionId
        Feed
        Inputs
        Message
        Metrics
        Outputs
        Overrides
        Result
        SourceDatasetIds
        StartTime
        Status
        TargetDatasetId
        Tasks
        WorkloadId
        WorkloadType
      }
      nextToken
    }
  }
`;
export const listResources = /* GraphQL */ `
  query ListResources(
    $filter: _ResourceFilter
    $limit: Int
    $nextToken: String
  ) {
    listResources(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        ClientAccountId
        Description
        Metrics
        Region
        ResourceId
        ResourceMigration
        ResourceSubtype
        ResourceType
        ResourceVersion
        StackCreated
        StackName
        StackUpdated
        ... on Client {
          ClientAccountAlias
          ClientConfiguration
        }
        ... on Credential {
          CredentialArn
          SecurityConfiguration
          TargetResource
          TargetResourceSpec
          UserArn
        }
        ... on Dataset {
          CatalogConfiguration
          CompactionConfiguration
          Location
          Migration
          Schema
          SecurityConfiguration
        }
        ... on Datastore {
          AuthorizedReadOnlyAccountIds
          AuthorizedReadWriteAccountIds
          Bucket
          BucketConfiguration
          SecurityConfiguration
        }
        ... on LandingZone {
          AuthorizedReadOnlyAccountIds
          AuthorizedReadWriteAccountIds
          Bucket
          BucketConfiguration
          SecurityConfiguration
        }
        ... on Stream {
          StorageConfiguration
          StreamConfiguration
        }
        ... on Subscription {
          DeliveryConfiguration
          SubscribedResource
        }
        ... on Workload {
          ArrivalFeedConfiguration
          ClusterConfiguration
          CompactionConfiguration
          ContainerType
          ControllerConfiguration
          ExecutionType
          WorkloadConfiguration
          WorkloadInputs
        }
      }
      nextToken
    }
  }
`;
